/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { decreaseLoading, increaseLoading } from './loading';
import {
  DocumentType,
  DocumentUploadOrderAndType,
} from '@portal/enum/documentType';
import { onboarding } from '@portal/config/app.json';
import { setHeader } from '@portal/repositories/securitySdkConfig';

import * as StorageService from '@portal/services/storage';
import * as MessageService from '@portal/services/message';

import OnboardingApi from '@portal/repositories/onboarding';

import {
  ONBOARDING_CELLPHONE_STATUS,
  ONBOARDING_CREATE_ACCOUNT,
  ONBOARDING_CREATE_ADDRESS,
  ONBOARDING_GET_ADDRESS,
  ONBOARDING_REGISTER_DEVICE,
  ONBOARDING_SAVE_USER_PHOTO,
  ONBOARDING_CUSTOM_DOCUMENT,
  ONBOARDING_SAVE_POWER_OF_ATTORNEY,
  ONBOARDING_VALIDATE_TOKEN,
  ONBOARDING_SAVE_USER_DOCUMENT,
  ONBOARDING_CREATE_PIN,
  ONBOARDING_TAX_ID_STATUS,
  ONBOARDING_TERMS_OF_USE,
  ONBOARDING_EMAIL_STATUS,
  ONBOARDING_LOGIN_STATUS,
  ONBOARDING_SETTINGS,
  ONBOARDING_ADD_PARTNER,
  ONBOARDING_GET_REPRESENTANT_ADDRESS,
  ONBOARDING_CNAE_DESCRIPTION,
  ONBOARDING_CNAE_CLEAR_STATUS,
  ONBOARDING_CADASTRAL_SITUATION,
  ONBOARDING_SAVE_REPRESENTANT_DOCUMENT,
  ONBOARDING_CLEAN_REPRESENTANT_DOCUMENT,
  ONBOARDING_SAVE_SOCIAL_CONTRACT,
  ONBOARDING_SAVE_MINUTES_OF_ELECTION,
  SET_INVITE_RESPONSE,
  GET_CBO,
  SET_CBO_ERROR,
  GET_CBO_SUB_GRAND_CHILD,
  GET_CBO_SUB_OCCUPATION,
  GET_CBO_SUB_SON_OCCUPATION,
  SET_ONBOARDING_CAF_INFO,
  GET_COUNTRIES,
  GET_STATES,
  GET_CITIES,
  GET_CITIES_ERROR,
  GET_STATES_ERROR,
  GET_COUNTRIES_ERROR,
  ONBOARDING_SAVE_COMPANY_STATUTE,
  ONBOARDING_SAVE_DECLARATION_BENEFICIARIES,
  SET_ONBOARDING_WEBVIEW_URL,
  GET_ONBOARDING_WEBVIEW_URL_ERROR,
  ONBOARDING_GET_ADDRESS_ERROR,
} from './actionTypes';
import ErrorsMessages from '@portal/enum/errors';

interface IValidateTaxId {
  type?: string;
  payload?: { status: string } | null;
}

type DispatchValidateTaxId = (arg: IValidateTaxId) => IValidateTaxId;

interface IValidateEmail {
  type?: string;
  payload?: { status: string } | null;
}

type DispatchValidateEmail = (arg: IValidateEmail) => IValidateEmail;

interface IValidateCellphone {
  type?: string;
  payload?: { status: string } | null;
}

interface IValidateLogin {
  type?: string;
  payload?: { status: string } | null;
}

type DispatchValidateCellphone = (
  arg: IValidateCellphone
) => IValidateCellphone;

type DispatchValidateLogin = (arg: IValidateLogin) => IValidateLogin;

interface IRegisterDevice {
  type?: string;
  payload?: boolean;
}

type DispatchRegisterDevice = (arg: IRegisterDevice) => IRegisterDevice;

interface IValidateDevice {
  type?: string;
  payload?: boolean;
}

type DispatchValidateDevice = (arg: IValidateDevice) => IValidateDevice;

// created for/to uploadDocumentsArray()

const getFileExtensionName = (file: File) =>
  file?.type ? file.type.split('/')[1] : '';

export interface DocumentToUploadTypeFile {
  type: Exclude<DocumentUploadOrderAndType, '99'>;
  fileFirst: File;
  fileSecond?: File;
  jwt?: string;
}

export interface DocumentToUploadTypeDefault {
  type:
    | DocumentUploadOrderAndType.DOCUMENT_CHN
    | DocumentUploadOrderAndType.DOCUMENT_RG
    | DocumentUploadOrderAndType.CUSTOM;
  fileFirst: File;
  fileSecond?: File;
  documentType?: DocumentType;
  jwtFirst?: string;
  jwtSecond?: string;
}

export type DocumentToUploadType =
  | DocumentToUploadTypeDefault
  | DocumentToUploadTypeFile;

export const validateTaxId =
  (value: string) => async (dispatch: DispatchValidateTaxId) => {
    dispatch(increaseLoading());
    try {
      const payload = await OnboardingApi.validateTaxId(value);
      dispatch({ type: ONBOARDING_TAX_ID_STATUS, payload: payload.status });

      if (
        payload.status === ErrorsMessages.RESTRICTED_LIST ||
        payload.status === ErrorsMessages.NOT_ALLOWED
      ) {
        MessageService.error(payload.status);
      }
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const validateCellphone =
  (value: string) => async (dispatch: DispatchValidateCellphone) => {
    dispatch(increaseLoading());
    try {
      const payload = await OnboardingApi.validateCellphone(value);
      dispatch({
        type: ONBOARDING_CELLPHONE_STATUS,
        payload: payload.status,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const validateCNAE = (value: string) => async (dispatch) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.validateCNAE(value);
    dispatch({
      type: ONBOARDING_CNAE_DESCRIPTION,
      payload: payload,
    });
  } catch (err) {
    if (err instanceof Error) {
      MessageService.error(err.message, { originalError: err });
    }
    dispatch({
      type: ONBOARDING_CNAE_DESCRIPTION,
      payload: null,
    });
  } finally {
    dispatch(decreaseLoading());
  }
};

export const inviteCode = (code: string) => async (dispatch) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.inviteCode(code);
    dispatch({
      type: SET_INVITE_RESPONSE,
      payload,
    });
    return payload;
  } catch (err) {
    if (err instanceof Error) {
      MessageService.error(err.message, { originalError: err });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};

export const cleanCNAEDescription = () => ({
  type: ONBOARDING_CNAE_CLEAR_STATUS,
  payload: null,
});

export const onboardingSettings =
  () => async (dispatch: DispatchValidateCellphone) => {
    dispatch(increaseLoading());
    try {
      const payload = await OnboardingApi.onboardingSettings();
      dispatch({
        type: ONBOARDING_SETTINGS,
        payload: payload,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const validateLogin =
  (value: string) => async (dispatch: DispatchValidateLogin) => {
    dispatch(increaseLoading());
    try {
      const payload = await OnboardingApi.validateLogin(value);
      dispatch({
        type: ONBOARDING_LOGIN_STATUS,
        payload,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const setValidateLogin = () => ({
  type: ONBOARDING_LOGIN_STATUS,
  payload: null,
});

export const validateEmail =
  (value: string) => async (dispatch: DispatchValidateEmail) => {
    dispatch(increaseLoading());
    try {
      const payload = await OnboardingApi.validateEmail(value);
      dispatch({
        type: ONBOARDING_EMAIL_STATUS,
        payload: payload.status,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const onboardingRegisterDevice =
  (body: models.OnboardingRegisterDeviceRequest) =>
  async (dispatch: DispatchRegisterDevice) => {
    dispatch(increaseLoading());
    try {
      await OnboardingApi.onboardingRegisterDevice(body);
      dispatch({ type: ONBOARDING_REGISTER_DEVICE, payload: true });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const onboardingValidateDevice =
  (body: models.OnboardingValidateTokenRequest) =>
  async (dispatch: DispatchValidateDevice) => {
    dispatch(increaseLoading());
    const deviceId = StorageService.getDeviceId();
    if (deviceId) {
      setHeader(StorageService.StorageItems.DEVICE_ID, deviceId);
    }

    try {
      await OnboardingApi.onboardingValidateToken(body);
      dispatch({ type: ONBOARDING_VALIDATE_TOKEN, payload: true });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error('TOKEN');
      }
    } finally {
      dispatch(decreaseLoading());
      dispatch({ type: ONBOARDING_VALIDATE_TOKEN, payload: false });
    }
  };

export const createAccount =
  (body: models.OnboardingRequest) => async (dispatch) => {
    dispatch(increaseLoading());

    try {
      const getLogin = () => {
        if (onboarding.emailLogin) {
          return body.account?.email;
        }
        if (onboarding.cpfLogin) {
          return body.account?.taxIdentifier;
        }
        return body.login;
      };

      const payload = await OnboardingApi.createAccount(body);
      const payloadLogin = await OnboardingApi.createAccountLogin({
        username: getLogin() ?? '',
        password: body.password ?? '',
      });
      dispatch({ type: ONBOARDING_CREATE_ACCOUNT, payload });
      StorageService.setItem('session-token', JSON.stringify(payloadLogin));
      setHeader(
        StorageService.StorageItems.AUTHORIZATION,
        `Bearer ${payloadLogin.accessToken}`
      );
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const getAddress =
  (cep: string, isRepresentant?: boolean) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const payload = await OnboardingApi.getAddress(cep);
      if (isRepresentant) {
        dispatch({ type: ONBOARDING_GET_REPRESENTANT_ADDRESS, payload });
      } else {
        dispatch({ type: ONBOARDING_GET_ADDRESS, payload });
        dispatch({ type: ONBOARDING_GET_ADDRESS_ERROR, payload: false });
      }
    } catch (err) {
      if (err instanceof Error) {
        if (err.message.toUpperCase() === ErrorsMessages.ADDRESS_NOT_FOUND) {
          if (!isRepresentant) {
            dispatch({ type: ONBOARDING_GET_ADDRESS_ERROR, payload: true });
          }
          return MessageService.warn(
            `APPLICATION.ERRORS.${ErrorsMessages.ADDRESS_NOT_FOUND_RETRY_MANUAL}`
          );
        }

        MessageService.error(err.message, { originalError: err });
      }
      if (!isRepresentant) {
        dispatch({ type: ONBOARDING_GET_ADDRESS_ERROR, payload: true });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const cleanRepresentantAddress = () => ({
  type: ONBOARDING_GET_REPRESENTANT_ADDRESS,
  payload: null,
});

export const getSettingsRemote = () => async (dispatch) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.getSettings();
    dispatch({ type: ONBOARDING_TERMS_OF_USE, payload: payload.terms });
  } catch (err) {
    if (err instanceof Error)
      MessageService.error(err.message, { originalError: err });
  } finally {
    dispatch(decreaseLoading());
  }
};

export const createAddress = (body: models.Address) => async (dispatch) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.createAddress(body);
    dispatch({ type: ONBOARDING_CREATE_ADDRESS, payload });
  } catch (err) {
    if (err instanceof Error) {
      MessageService.error(err.message, { originalError: err });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};

export const cleanAddress = () => ({
  type: ONBOARDING_CREATE_ADDRESS,
  payload: null,
});

export const createPartners = (body: models.Partners) => async (dispatch) => {
  dispatch(increaseLoading());
  try {
    await OnboardingApi.addPartner(body);
    dispatch({ type: ONBOARDING_ADD_PARTNER, payload: true });
  } catch (err) {
    if (err instanceof Error) {
      MessageService.error(err.message, { originalError: err });
    }
  } finally {
    dispatch(decreaseLoading());
    dispatch({ type: ONBOARDING_ADD_PARTNER, payload: false });
  }
};

export const uploadPhoto =
  (
    extension: string,
    documentToUpload?: File,
    childFunction?: boolean,
    idwallSDKToken?: string,
    jwt?: string,
    pj?: boolean
  ) =>
  async (dispatch) => {
    if (!childFunction) dispatch(increaseLoading());
    try {
      if (idwallSDKToken) {
        const payloadSdkToken = await OnboardingApi.saveDocument({
          documentFront: {
            type: DocumentType.ID_WALL_SELFIE_DOCS,
            ocrToken: idwallSDKToken,
            pj,
          },
        });

        dispatch({
          type: ONBOARDING_SAVE_USER_PHOTO,
          payload: payloadSdkToken,
        });
      } else {
        const payload: models.OnboardingGetImageUrlResponse =
          await OnboardingApi.getImageUrl(extension, DocumentType.SELF);
        if (documentToUpload) {
          await OnboardingApi.uploadDocument(payload.url, documentToUpload);
        }

        const payloadPhoto = await OnboardingApi.saveDocument({
          documentFront: {
            bucket: payload.bucket,
            type: DocumentType.SELF,
            jwt,
          },
        });

        dispatch({ type: ONBOARDING_SAVE_USER_PHOTO, payload: payloadPhoto });
      }
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (!childFunction) dispatch(decreaseLoading());
    }
  };

export const uploadRepresentativePhoto =
  (extension: string, documentToUpload?: File, jwt?: string) =>
  async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(extension, DocumentType.SELF);
      if (documentToUpload) {
        await OnboardingApi.uploadDocument(payload.url, documentToUpload);
      }

      await OnboardingApi.saveDocument({
        documentFront: {
          bucket: payload.bucket,
          type: DocumentType.SELF,
          jwt,
        },
      });
      dispatch({
        type: ONBOARDING_SAVE_REPRESENTANT_DOCUMENT,
        payload: [
          {
            bucket: payload.bucket,
            type: DocumentType.SELF,
          },
        ],
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const uploadDocument =
  (
    extension: string,
    documentToUpload: File,
    type = DocumentType.CUSTOM,
    childFunction?: boolean
  ) =>
  async (dispatch) => {
    if (!childFunction) dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(extension, type);
      await OnboardingApi.uploadDocument(payload.url, documentToUpload);
      const payloadPhoto = await OnboardingApi.saveDocument({
        documentFront: {
          bucket: payload.bucket,
          type,
        },
      });

      dispatch({
        type:
          type === DocumentType.CUSTOM
            ? ONBOARDING_CUSTOM_DOCUMENT
            : ONBOARDING_CADASTRAL_SITUATION,
        payload: payloadPhoto,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (!childFunction) dispatch(decreaseLoading());
    }
  };

export const uploadPowerOfAttorney =
  (extension: string, documentToUpload: File, childFunction?: boolean) =>
  async (dispatch) => {
    if (!childFunction) dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(
          extension,
          DocumentType.POWER_OF_ATTORNEY
        );
      await OnboardingApi.uploadDocument(payload.url, documentToUpload);
      const payloadPhoto = await OnboardingApi.saveDocument({
        documentFront: {
          bucket: payload.bucket,
          type: DocumentType.POWER_OF_ATTORNEY,
        },
      });

      dispatch({
        type: ONBOARDING_SAVE_POWER_OF_ATTORNEY,
        payload: payloadPhoto,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (!childFunction) dispatch(decreaseLoading());
    }
  };

export const uploadSocialContract =
  (extension: string, documentToUpload: File, childFunction?: boolean) =>
  async (dispatch) => {
    if (!childFunction) dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(
          extension,
          DocumentType.SOCIAL_CONTRACT
        );

      await OnboardingApi.uploadDocument(payload.url, documentToUpload);

      const payloadPhoto = await OnboardingApi.saveDocument({
        documentFront: {
          bucket: payload.bucket,
          type: DocumentType.SOCIAL_CONTRACT,
        },
      });

      dispatch({
        type: ONBOARDING_SAVE_SOCIAL_CONTRACT,
        payload: payloadPhoto,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (!childFunction) dispatch(decreaseLoading());
    }
  };

export const uploadCompanyStatute =
  (extension: string, documentToUpload: File, childFunction?: boolean) =>
  async (dispatch) => {
    if (!childFunction) dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(
          extension,
          DocumentType.COMPANY_STATUTE
        );

      await OnboardingApi.uploadDocument(payload.url, documentToUpload);

      const payloadPhoto = await OnboardingApi.saveDocument({
        documentFront: {
          bucket: payload.bucket,
          type: DocumentType.COMPANY_STATUTE,
        },
      });

      dispatch({
        type: ONBOARDING_SAVE_COMPANY_STATUTE,
        payload: payloadPhoto,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (!childFunction) dispatch(decreaseLoading());
    }
  };

export const uploadDeclarationBeneficiaries =
  (extension: string, documentToUpload: File, childFunction?: boolean) =>
  async (dispatch) => {
    if (!childFunction) dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(
          extension,
          DocumentType.DECLARATION_OF_BENEFICIARIES
        );

      await OnboardingApi.uploadDocument(payload.url, documentToUpload);

      const payloadPhoto = await OnboardingApi.saveDocument({
        documentFront: {
          bucket: payload.bucket,
          type: DocumentType.DECLARATION_OF_BENEFICIARIES,
        },
      });

      dispatch({
        type: ONBOARDING_SAVE_DECLARATION_BENEFICIARIES,
        payload: payloadPhoto,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (!childFunction) dispatch(decreaseLoading());
    }
  };

export const uploadMinutesOfElection =
  (extension: string, documentToUpload: File, childFunction?: boolean) =>
  async (dispatch) => {
    if (!childFunction) dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(
          extension,
          DocumentType.MINUTES_OF_ELECTION
        );
      await OnboardingApi.uploadDocument(payload.url, documentToUpload);
      const payloadPhoto = await OnboardingApi.saveDocument({
        documentFront: {
          bucket: payload.bucket,
          type: DocumentType.MINUTES_OF_ELECTION,
        },
      });

      dispatch({
        type: ONBOARDING_SAVE_MINUTES_OF_ELECTION,
        payload: payloadPhoto,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (!childFunction) dispatch(decreaseLoading());
    }
  };

export const uploadSocialContractRepresentative =
  (extension: string, documentToUpload: File) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(
          extension,
          DocumentType.SOCIAL_CONTRACT
        );
      await OnboardingApi.uploadDocument(payload.url, documentToUpload);

      dispatch({
        type: ONBOARDING_SAVE_REPRESENTANT_DOCUMENT,
        payload: [
          {
            bucket: payload.bucket,
            type: DocumentType.SOCIAL_CONTRACT,
          },
        ],
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const uploadDocumentCNH =
  (
    extension: string,
    fileSelectedCnhFront: File,
    fileSelectedCnhBack?: File | null,
    childFunction?: boolean,
    orderType?: number,
    jwtFirst?: string,
    jwtSecond?: string
  ) =>
  async (dispatch) => {
    if (!childFunction) dispatch(increaseLoading());
    try {
      const frontType: DocumentType = ((): DocumentType => {
        if (orderType) {
          return DocumentType.DIGITAL_CNH;
        } else if (fileSelectedCnhBack) {
          return DocumentType.CNH_FRONT;
        } else {
          return DocumentType.CNH;
        }
      })();

      const payloadFront = await OnboardingApi.getImageUrl(
        extension,
        frontType
      );

      await OnboardingApi.uploadDocument(
        payloadFront.url,
        fileSelectedCnhFront
      );

      let fillesArray: models.OnboardingUserPhotoRequest = {
        documentFront: {
          bucket: payloadFront.bucket,
          type: frontType,
          jwt: jwtFirst,
        },
      };

      if (fileSelectedCnhBack) {
        const payloadBack: models.OnboardingGetImageUrlResponse =
          await OnboardingApi.getImageUrl(extension, DocumentType.CNH_BACK);
        await OnboardingApi.uploadDocument(
          payloadBack.url,
          fileSelectedCnhBack
        );

        fillesArray = {
          ...fillesArray,
          documentBack: {
            bucket: payloadBack.bucket,
            type: DocumentType.CNH_BACK,
            jwt: jwtSecond,
          },
        };
      }

      const payloadPhoto = await OnboardingApi.saveDocument(fillesArray);

      dispatch({ type: ONBOARDING_SAVE_USER_DOCUMENT, payload: payloadPhoto });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (!childFunction) dispatch(decreaseLoading());
    }
  };

export const uploadDocumentRG =
  (
    extension: string,
    documentToUploadFront: File,
    documentToUploadBack: File,
    childFunction?: boolean,
    jwtFront?: string,
    jwtSecond?: string
  ) =>
  async (dispatch) => {
    if (!childFunction) dispatch(increaseLoading());
    try {
      const payloadFront: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(extension, DocumentType.RG_FRONT);
      const payloadBack: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(extension, DocumentType.RG_BACK);

      await OnboardingApi.uploadDocument(
        payloadFront.url,
        documentToUploadFront
      );
      await OnboardingApi.uploadDocument(payloadBack.url, documentToUploadBack);

      const payloadPhoto = await OnboardingApi.saveDocument({
        documentFront: {
          bucket: payloadFront.bucket,
          type: DocumentType.RG_FRONT,
          jwt: jwtFront,
        },
        documentBack: {
          bucket: payloadBack.bucket,
          type: DocumentType.RG_BACK,
          jwt: jwtSecond,
        },
      });

      dispatch({ type: ONBOARDING_SAVE_USER_DOCUMENT, payload: payloadPhoto });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      if (!childFunction) dispatch(decreaseLoading());
    }
  };

export const cleanRepresentativeDocuments = () => ({
  type: ONBOARDING_CLEAN_REPRESENTANT_DOCUMENT,
  payload: null,
});

export const uploadPowerOfAttorneyNewRepresentative =
  (extension: string, documentToUpload: File) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(
          extension,
          DocumentType.POWER_OF_ATTORNEY
        );
      await OnboardingApi.uploadDocument(payload.url, documentToUpload);

      dispatch({
        type: ONBOARDING_SAVE_REPRESENTANT_DOCUMENT,
        payload: [
          {
            bucket: payload.bucket,
            type: DocumentType.POWER_OF_ATTORNEY,
          },
        ],
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const uploadProofOfAddressRepresentative =
  (extension: string, documentToUpload: File) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const payload: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(
          extension,
          DocumentType.MEMBERS_PROOF_ADDRESS
        );
      await OnboardingApi.uploadDocument(payload.url, documentToUpload);

      dispatch({
        type: ONBOARDING_SAVE_REPRESENTANT_DOCUMENT,
        payload: [
          {
            bucket: payload.bucket,
            type: DocumentType.MEMBERS_PROOF_ADDRESS,
          },
        ],
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const uploadDocumentCNHRepresentative =
  (extension: string, fileSelectedCnhFront: File, fileSelectedCnhBack?: File) =>
  async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const payloadFront: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(extension, DocumentType.CNH);
      await OnboardingApi.uploadDocument(
        payloadFront.url,
        fileSelectedCnhFront
      );
      let payloadPhoto = [
        {
          bucket: payloadFront.bucket,
          type: DocumentType.CNH,
        },
      ];

      if (fileSelectedCnhBack) {
        const payloadBack: models.OnboardingGetImageUrlResponse =
          await OnboardingApi.getImageUrl(extension, DocumentType.CNH);
        await OnboardingApi.uploadDocument(
          payloadBack.url,
          fileSelectedCnhBack
        );

        payloadPhoto = [
          {
            bucket: payloadFront.bucket,
            type: DocumentType.CNH,
          },
          {
            bucket: payloadBack.bucket,
            type: DocumentType.CNH,
          },
        ];
      }

      dispatch({
        type: ONBOARDING_SAVE_REPRESENTANT_DOCUMENT,
        payload: payloadPhoto,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const uploadDocumentRGRepresentative =
  (
    extension: string,
    documentToUploadFront: File,
    documentToUploadBack: File
  ) =>
  async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const payloadFront: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(extension, DocumentType.RG_FRONT);
      const payloadBack: models.OnboardingGetImageUrlResponse =
        await OnboardingApi.getImageUrl(extension, DocumentType.RG_BACK);

      await OnboardingApi.uploadDocument(
        payloadFront.url,
        documentToUploadFront
      );
      await OnboardingApi.uploadDocument(payloadBack.url, documentToUploadBack);

      dispatch({
        type: ONBOARDING_SAVE_REPRESENTANT_DOCUMENT,
        payload: [
          {
            bucket: payloadFront.bucket,
            type: DocumentType.RG_FRONT,
          },
          {
            bucket: payloadBack.bucket,
            type: DocumentType.RG_BACK,
          },
        ],
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const createPin =
  (body: models.OnboardingCreatePinRequest) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      await OnboardingApi.createPin(body);
      dispatch({ type: ONBOARDING_CREATE_PIN, payload: true });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error('PIN');
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const dataRetry =
  (body: models.DataRetryRequest) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      await OnboardingApi.dataRetry(body);

      setTimeout(() => {
        window.location.href = '/documentos-pendentes';
      }, 500);
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const uploadDocumentsArray =
  (items: DocumentToUploadType[]) => async (dispatch) => {
    if (!items || items.length === 0) return;
    dispatch(increaseLoading());
    const orderedList = items.sort((a, b) => a.type - b.type);
    try {
      for (const document of orderedList) {
        const { type, fileFirst, fileSecond, ...item } = document;

        switch (type) {
          case DocumentUploadOrderAndType.SELFIE:
            // eslint-disable-next-line no-case-declarations
            const { jwt } = document;

            await dispatch(
              uploadPhoto(
                getFileExtensionName(fileFirst),
                fileFirst,
                true,
                undefined,
                jwt
              )
            );
            break;

          case DocumentUploadOrderAndType.DOCUMENT_CHN:
            // eslint-disable-next-line no-case-declarations
            const { jwtFirst, jwtSecond } = item as DocumentToUploadTypeDefault;

            await dispatch(
              uploadDocumentCNH(
                getFileExtensionName(fileFirst),
                fileFirst,
                fileSecond,
                true,
                undefined,
                jwtFirst,
                jwtSecond
              )
            );
            break;

          case DocumentUploadOrderAndType.DOCUMENT_RG:
            if (fileSecond) {
              const { jwtFirst, jwtSecond } =
                item as DocumentToUploadTypeDefault;

              await dispatch(
                uploadDocumentRG(
                  getFileExtensionName(fileSecond),
                  fileFirst,
                  fileSecond,
                  true,
                  jwtFirst,
                  jwtSecond
                )
              );
            }
            break;

          case DocumentUploadOrderAndType.SOCIAL_CONTRACT:
            await dispatch(
              uploadSocialContract(
                getFileExtensionName(fileFirst),
                fileFirst,
                true
              )
            );

            break;

          case DocumentUploadOrderAndType.COMPANY_STATUTE:
            await dispatch(
              uploadCompanyStatute(
                getFileExtensionName(fileFirst),
                fileFirst,
                true
              )
            );

            break;

          case DocumentUploadOrderAndType.DECLARATION_OF_BENEFICIARIES:
            await dispatch(
              uploadDeclarationBeneficiaries(
                getFileExtensionName(fileFirst),
                fileFirst,
                true
              )
            );

            break;

          case DocumentUploadOrderAndType.MINUTES_OF_ELECTION:
            await dispatch(
              uploadMinutesOfElection(
                getFileExtensionName(fileFirst),
                fileFirst,
                true
              )
            );

            break;

          case DocumentUploadOrderAndType.POWER_OF_ATTORNEY:
            await dispatch(
              uploadPowerOfAttorney(
                getFileExtensionName(fileFirst),
                fileFirst,
                true
              )
            );
            break;

          case DocumentUploadOrderAndType.DIGITAL_CNH:
            await dispatch(
              uploadDocumentCNH(
                getFileExtensionName(fileFirst),
                fileFirst,
                fileSecond,
                true,
                type
              )
            );
            break;

          case DocumentUploadOrderAndType.CUSTOM:
            if ('documentType' in item) {
              await dispatch(
                uploadDocument(
                  getFileExtensionName(fileFirst),
                  fileFirst,
                  item.documentType,
                  true
                )
              );
            } else {
              await dispatch(
                uploadDocument(
                  getFileExtensionName(fileFirst),
                  fileFirst,
                  DocumentType.CUSTOM,
                  true
                )
              );
            }
            break;

          default:
            break;
        }
      }
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const getCbo = () => async (dispatch) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.cboPrimary();

    dispatch({
      type: GET_CBO,
      payload,
    });
  } catch (err) {
    if (err instanceof Error) {
      dispatch({
        payload: err,
        type: SET_CBO_ERROR,
      });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};

export const getSubGrandchild = (id: string) => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.getCboOccupation(id);

    dispatch({
      type: GET_CBO_SUB_OCCUPATION,
      payload,
    });
  } catch (err) {
    if (err instanceof Error) {
      dispatch({
        payload: err,
        type: SET_CBO_ERROR,
      });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};

export const getSubGreatGrandson = (id: string) => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.getCboOccupation(id);
    dispatch({
      type: GET_CBO_SUB_SON_OCCUPATION,
      payload,
    });
  } catch (err) {
    if (err instanceof Error) {
      dispatch({
        payload: err,
        type: SET_CBO_ERROR,
      });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};

export const getSubGreatGreatGrandson =
  (id: string) => async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      const payload = await OnboardingApi.getCboOccupation(id);
      dispatch({
        type: GET_CBO_SUB_GRAND_CHILD,
        payload,
      });
    } catch (err) {
      if (err instanceof Error) {
        dispatch({
          payload: err,
          type: SET_CBO_ERROR,
        });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const setOccupationError =
  (item: models.CboOccupations | null) => async (dispatch: any) => {
    dispatch(increaseLoading());
    try {
      dispatch({
        type: GET_CBO_SUB_OCCUPATION,
        payload: item,
      });

      dispatch({
        type: GET_CBO_SUB_GRAND_CHILD,
        payload: item,
      });

      dispatch({
        type: GET_CBO_SUB_SON_OCCUPATION,
        payload: item,
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          payload: error,
          type: SET_CBO_ERROR,
        });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const setOnboardingCafInfo =
  (info: models.IOnboardingCafInfo) => (dispatch: any) => {
    dispatch({
      type: SET_ONBOARDING_CAF_INFO,
      payload: info,
    });
  };

export const getCountries = () => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.getCountries();
    dispatch({
      type: GET_COUNTRIES,
      payload,
    });
  } catch (err) {
    if (err instanceof Error) {
      dispatch({
        payload: err,
        type: GET_COUNTRIES_ERROR,
      });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};
export const getStates = () => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.getStates();
    dispatch({
      type: GET_STATES,
      payload,
    });
  } catch (err) {
    if (err instanceof Error) {
      dispatch({
        payload: err,
        type: GET_STATES_ERROR,
      });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};
export const getCities = (uf: string) => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const payload = await OnboardingApi.getCities(uf);
    dispatch({
      type: GET_CITIES,
      payload,
    });
  } catch (err) {
    if (err instanceof Error) {
      dispatch({
        payload: err,
        type: GET_CITIES_ERROR,
      });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};

export const getWebviewUrl = () => async (dispatch: any) => {
  dispatch(increaseLoading());
  try {
    const data = await OnboardingApi.getWebviewUrl();
    dispatch({
      payload: data,
      type: SET_ONBOARDING_WEBVIEW_URL,
    });
  } catch (err) {
    if (err instanceof Error) {
      dispatch({
        payload: err,
        type: GET_ONBOARDING_WEBVIEW_URL_ERROR,
      });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};
